import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Alert, Paper } from '@mui/material';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const Unsubscribe = () => {
    const { t } = useTranslation();
    const [step, setStep] = useState(1); // 1: Request Code, 2: Verify Code
    const [email, setEmail] = useState('');
    const [code, setCode] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const requestCode = async () => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email.trim() || !emailPattern.test(email.trim())) {
            setError(t('unsubscribe.invalidEmail', 'Please enter a valid email address.'));
            return;
        }
        try {
            setError('');
            setMessage('');
            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/newsletter/unsubscribe/request-code`, { email: email.trim() });
            setMessage(t('unsubscribe.codeSent'));
            setStep(2);
        } catch (err) {
            setError(err.response?.data?.message || t('unsubscribe.requestCodeError'));
        }
    };

    const verifyCodeAndUnsubscribe = async () => {
        try {
            setError('');
            setMessage('');
            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/newsletter/unsubscribe`, { email, code });
            setMessage(t('unsubscribe.successMessage'));
        } catch (err) {
            setError(err.response?.data?.message || t('unsubscribe.unsubscribeError'));
        }
    };

    return (
        <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
        p={2}
    >
        <Paper elevation={3} sx={{ p: 4, maxWidth: 400, width: '100%' }}>
            <Typography variant="h5" gutterBottom>
                {t('unsubscribe.title')}
            </Typography>
            <Typography variant="body1" color="textSecondary" gutterBottom>
                {t('unsubscribe.description')}
            </Typography>
            {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

            {step === 1 && (
                <>
                    <TextField
                        label={t('unsubscribe.emailLabel')}
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        fullWidth
                        required
                        sx={{ mb: 2 }}
                    />
                    <Button variant="contained" color="primary" fullWidth onClick={requestCode}>
                        {t('unsubscribe.requestCodeButton')}
                    </Button>
                </>
            )}

            {step === 2 && (
                <>
                    <Typography gutterBottom>
                        {t('unsubscribe.enterCodePrompt', { email })}
                    </Typography>
                    <TextField
                        label={t('unsubscribe.codeLabel')}
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        fullWidth
                        required
                        sx={{ mb: 2 }}
                    />
                    <Button variant="contained" color="primary" fullWidth onClick={verifyCodeAndUnsubscribe}>
                        {t('unsubscribe.confirmButton')}
                    </Button>
                    <Button variant="text" size="small" sx={{ mt: 1 }} onClick={() => { setStep(1); setCode(''); setError(''); setMessage(''); }}>
                        {t('unsubscribe.backButton', 'Back')}
                    </Button>
                </>
            )}
            </Paper>
        </Box>
    );
};

export default Unsubscribe;
